// @flow
// sentry error tracking
import * as Sentry from '@sentry/browser'
import { Vue as IntegrationVue } from '@sentry/integrations'

// TODO: expose captureMessage and captureException methods from here
// TODO: and not use directly (so we can switch out lib better)

/**
 * @param {Vue} VueInstance
 */
const errorTrackerInit = (VueInstance: any) => {
  if (Laravel && Laravel.sentryDsn) {
    Sentry.init({
      dsn: Laravel.sentryDsn,
      environment: Laravel.env,
      sampleRate: 0.5,
      allowUrls: [/fitnessblender\.com/],
      denyUrls: [
        // chrome extension errors
        /extensions\//i,
        /^chrome:\/\//i,
      ],
      ignoreErrors: [
        // can safely ignore this
        // @see https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402
        'ResizeObserver loop limit exceeded',
      ],
      integrations: [
        new IntegrationVue({
          Vue: VueInstance,
          attachProps: true,
          logErrors: true,
        }),
      ],
      // @see https://github.com/getsentry/sentry-javascript/issues/2210
      // chrome extensions can cause errors
      beforeSend(event) {
        // try catch is only so you dont have to assert any null values in that long chain
        try {
          if (event.extra.__serialized__.detail.reason.message === 'Extension context invalidated.')
            return null
        } catch (sendErr) {
          return event
        }
        return event
      },
    })

    // set user based on anonymized ip and user id base64 hash
    if (window.btoa && window.navigator) {
      let userId = ''

      if (window.Laravel) {
        if (window.Laravel.user && window.Laravel.user.anonymizedIp) {
          userId += `${window.Laravel.user.anonymizedIp} `
        }
      }

      if (navigator.language) {
        userId += `${navigator.language} `
      }

      if (navigator.platform) {
        userId += `${navigator.platform} `
      }

      if (navigator.hardwareConcurrency) {
        userId += `${navigator.hardwareConcurrency} `
      }

      if (navigator.vendor) {
        userId += `${navigator.vendor} `
      }

      if (navigator.plugins && navigator.plugins.length) {
        userId += `${navigator.plugins.length} `
      }

      Sentry.setUser({ id: window.btoa(userId) })
      // console.log('got here', window.Laravel, navigator, userId, window.btoa(userId));
    }
    // end set user
  }
}
export default errorTrackerInit

/**
 * Helper method to avoid being tightly coupled with sentry
 * @param {Error} err
 */
export const captureException = (err: Error) => {
  return Sentry.captureException(err)
}

/**
 * Helper method to avoid being tightly coupled with sentry, includes context
 */
export const captureMessage = ({
  msg,
  extras,
  level,
}: {
  msg: string,
  extras: {},
  level?: string,
}) => {
  return Sentry.withScope((scope) => {
    scope.setExtras(extras)
    scope.setLevel(level || 'error') //  fatal, error, warning, info

    // send error
    return Sentry.captureMessage(msg)
  })
}
